
import store from "@/store";


export default {
  component: () => import("@/modules/user/layouts/UserLayout.vue"),
  children: [
    
    {
      path: "/becas",
      name: "beca",
      component: () => import("@/modules/user/views/InfoBecasView.vue"),
      beforeEnter: (to, from, next) => {
        if (!sessionStorage.getItem('token')) next("/login");
        else {  
          store.commit('user/clearArchivos')
          next();
        }
      },
    },
    {
      path: "/solicitud",
      name: "solicitud",
      component: () => import("@/modules/user/views/FormBecaView.vue"),
      beforeEnter: (to, from, next) => {
        if (!sessionStorage.getItem('token')) next("/login");
        else next();
      },
    },
  ],
};
